import { Base } from '@studiometa/js-toolkit';

const FIELD_MAP = {
  name: 'first_name',
  'name-1': 'last_name',
  email: 'email_address',
  phone: 'phone_number',
  text: 'company',
  'country-1': 'country',
  'text-1': 'postal_code',
  'text-2': 'city',
  'text-3': 'website',
  'select-1': 'main_activity',
  'select-2': 'how_did_you_find_us',
  textarea: 'project_description',
  file2: 'attachment',
};

/**
 * QuoteFormTracking — pushes a request_quote_pro GTM event on quote form submit.
 * Intercepts fetch requests sent by the Powerful Form Builder app.
 */
export default class QuoteFormTracking extends Base {
  static config = {
    name: 'QuoteFormTracking',
  };

  /**
   * Intercepts window.fetch to detect Powerful Form Builder submissions
   * and push a request_quote_pro event to the GTM dataLayer.
   */
  mounted() {
    window.dataLayer = window.dataLayer || [];

    this._originalFetch = window.fetch;
    window.fetch = new Proxy(this._originalFetch, {
      apply(target, that, args) {
        const options = args[1] || {};
        const body = options.body;
        const temp = target.apply(that, args);

        temp
          .then((res) => {
            if (res.ok && res.url.includes('powerfulform') && res.url.includes('send')) {
              const parsedBody = {};
              if (body instanceof FormData) {
                body.forEach((value, key) => {
                  parsedBody[FIELD_MAP[key] ?? key] = value;
                });
              }
              window.dataLayer.push({
                event: 'request_quote_pro',
                form_data: parsedBody,
              });
            }
          })
          .catch((_error) => _error);

        return temp;
      },
    });
  }

  /**
   * Restore the original window.fetch on component teardown.
   */
  destroyed() {
    window.fetch = this._originalFetch;
  }
}
